import React from "react";
import { HeaderBar } from "@sonder/ui/source/styled/fragments/HeaderBar";
import {
  Scroller,
  ScrollerContent,
} from "@sonder/ui/source/styled/fragments/Scroller";

interface ScheduleHeaderProps {
  children: React.ReactNode;
}

export const ScheduleHeader = ({ children }: ScheduleHeaderProps) => (
  <Scroller>
    <ScrollerContent>
      <HeaderBar>{children}</HeaderBar>
    </ScrollerContent>
  </Scroller>
);
